import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../pages/AuthPages.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post('/api/auth/forgot-password', { email });
      setMessage(response.data.message || 'Password reset link has been sent to your email');
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <section className="cr-card auth-card">
        <h1>Reset Password</h1>
        {message && <p className="auth-msg success" role="status">{message}</p>}
        {error && <p className="auth-msg error" role="alert">{error}</p>}

        <form onSubmit={handleSubmit} className="auth-form" noValidate>
          <div className="auth-field">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              className="cr-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </div>
          <button type="submit" className="cr-btn solid auth-btn" disabled={loading}>
            {loading ? 'Sending' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-links">
          <p><Link to="/login">Back to Login</Link></p>
        </div>
      </section>
    </div>
  );
};

export default ForgotPassword;
